import React, { useEffect, useState } from 'react';

import './PrivacyPolicy.css'
import CookieModal from './CookieModal'
import Cookies from 'js-cookie';

const CookieTab = () => {
    const [cookieAccepted, setCookieAccepted] = useState(false);

    // Check the cookie value when the component mounts
    useEffect(() => {
        const cookieValue = Cookies.get('cookieAccepted');
        if (cookieValue === 'true') {
            setCookieAccepted(true);
        }
    }, []);

    // Function to handle accepting cookies
    const handleAcceptCookies = () => {
        Cookies.set('cookieAccepted', 'true', { expires: 30 });
        setCookieAccepted(true); // Update the state to true
    };
    return (
        <>
            <div className={cookieAccepted ? 'tabOuterNone' : 'tabOuter'}>
                <div className='tabInner'>
                    <div className='cookTextSection'>
                        <div className="headiungText">You rely on Bus Arabia for trust and transparency</div>
                        <div className='cookieNote'>
                            We use cookies and other tracking technologies to deliver and personalize content and ads, enable features, measure site performance, and enable social media sharing. You can choose to customize your preferences
                            <a target="_blank">Learn more about our Cookie Policy.</a>
                        </div>
                    </div>
                    <div className='buttonSec'>
                        <button className='allowAllBtn' onClick={handleAcceptCookies}>Allow all</button>
                        {/* <button className='prefText'>Cookie preferences</button> */}
                        <CookieModal setCookieAccepted={setCookieAccepted} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CookieTab
